import axios from 'axios';

const initSamlUrl = '/api/v1/authenticate/init';
const authenticateUrl = '/api/v1/authenticate';

function collectDeviceInfo() {
  let renderer = 'none';
  try {
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl');
    const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
    renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
  } catch {} // eslint-disable-line no-empty

  // prettier-ignore
  return [navigator.hardwareConcurrency, navigator.deviceMemory, renderer].join(':');
}

function handleError(e, setError) {
  console.error(e.message);

  if (e.response?.status === 500) {
    setError('Something went wrong, please contact support!');
  } else if (e.response?.data?.error) {
    setError(e.response.data.error);
  }
}

export const login = async ({
  authorizationKey,
  email,
  onSuccess,
  password,
  otp,
  setError,
  setIsOtpRequired,
  setOtpDetails,
  trustDevice,
  targetApp,
  workstationCode,
}) => {
  try {
    const payload = { email, password, otp, trust_device: trustDevice };
    if (authorizationKey) {
      payload.oauth_authorization_key = authorizationKey;
    }
    if (trustDevice) {
      payload.device = collectDeviceInfo();
    }
    if (targetApp) {
      payload.target_app = targetApp;
    }
    if (workstationCode) {
      payload.workstation_code = workstationCode;
    }
    const { status, data } = await axios.post(authenticateUrl, payload);

    if (status === 201 || onSuccess) {
      if (data.otp_required_for_login) {
        setIsOtpRequired(true);
        setOtpDetails({
          email,
          password,
          trustDevice,
          otpSecret: data.otp_secret,
          requiredAction: data.required_action,
          otpProvisioningUri: data.otp_provisioning_uri,
        });
      } else {
        if (onSuccess) {
          onSuccess(data);
        } else {
          window.location.replace(data.redirect_url);
        }
        return;
      }
    }
  } catch (e) {
    handleError(e, setError);
  }
};

export const fetchAuthFlow = async ({
  email,
  setAuthFlow,
  setError,
  authorizationKey,
  targetApp,
  workstationCode,
}) => {
  try {
    const payload = { email };
    if (authorizationKey) {
      payload.oauth_authorization_key = authorizationKey;
    }
    if (targetApp) {
      payload.target_app = targetApp;
    }
    if (workstationCode) {
      payload.workstation_code = workstationCode;
    }
    const { data } = await axios.post(initSamlUrl, payload);

    setAuthFlow(data);
  } catch (e) {
    handleError(e, setError);
  }
};
